// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"external-experience_wrapper__3y5Eo","title":"external-experience_title__L3kNk","text1":"external-experience_text1__2V79B","text2":"external-experience_text2__PmbpD"};